import { ReactNode, useMemo } from "react"

import { FeatureFlagReadModel, FlagState } from "featureFlags/domain/flag"
import { FeatureFlagReadModelFactory } from "featureFlags/features/getFeatureFlag/factory"

interface RenderBasedOnFlagProps {
  flagName: string
  flagReadModel?: FeatureFlagReadModel
  FlagEnabledComponent: ReactNode
  FlagDisabledComponent: ReactNode
}

const RenderBasedOnFlag = ({
  flagName,
  flagReadModel = new FeatureFlagReadModelFactory().build(),
  FlagEnabledComponent,
  FlagDisabledComponent
}: RenderBasedOnFlagProps) => {
  const flag = useMemo(
    () => flagReadModel.getByName(flagName),
    [flagName, flagReadModel]
  )

  if (flag.getCurrentState() === FlagState.Enabled) {
    return FlagEnabledComponent
  } else {
    return FlagDisabledComponent
  }
}

export default RenderBasedOnFlag
